import { baseApi } from './baseApi'
import { ILoginParams } from '../../types/app'

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    authCheck: builder.query<unknown, void>({
      query: () => '/auth/me',
    }),
    login: builder.mutation<{ token: string }, ILoginParams>({
      query: (params) => ({
        url: '/auth/login',
        method: 'POST',
        body: params,
      }),
    }),
  }),
})

export const { useAuthCheckQuery, useLazyAuthCheckQuery, useLoginMutation } =
  authApi
